import { useEffect, useState } from "react";
import { MdOutlineStar } from "react-icons/md"; // Import the star icon
import { useLocation, useNavigate } from "react-router-dom";
import axiosClient from "../../axios-client";

function ReportList({ searchQuery, currentPage, reportsPerPage }) {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [savedReports, setSavedReports] = useState([]); // Array to store IDs of saved reports
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const userID = localStorage.getItem("userID");

  const handleViewReport = (report) => {
    navigate(`/report`, { state: report });
  };

  const toggleSaveReport = async (reportId) => {
    console.log(`Toggling save status for report ID: ${reportId}`);

    try {
      const isSaved = savedReports.includes(reportId);
      let updatedSavedReports;

      if (isSaved) {
        // Remove reportId from savedReports and run delete API
        updatedSavedReports = savedReports.filter((id) => id !== reportId);
        await axiosClient.delete(`/users/delete-saved-report/`, {
          data: {
            userId: userID,
            reportId: reportId,
          },
        });
        console.log("Report deleted successfully");
      } else {
        // Add reportId to savedReports
        updatedSavedReports = [...savedReports, reportId];
      }
      await axiosClient.put(`users/save/report/${userID}`, {
        reportIds: updatedSavedReports,
      });
      // Sync updated state with the backend
      await axiosClient.get(`/users/saved/report/${userID}`, {
        // reportIds: updatedSavedReports, // Send the updated array to the backend
      });

      // Update the local state
      setSavedReports(updatedSavedReports);
    } catch (error) {
      console.error("Error toggling save report:", error);
    }
  };

  useEffect(() => {
    if (location.state && location.state.reports) {
      setReports(location.state.reports);
      setLoading(false);
    } else {
      const fetchReports = async () => {
        try {
          const response = await axiosClient.get("/reports/getReport");
          setReports(Array.isArray(response.data) ? response.data : []);

          if (userID) {
            try {
              // Fetch saved reports for the user if logged in
              const savedResponse = await axiosClient.get(
                `/users/saved/report/${userID}`
              );
              const savedReportIds =
                savedResponse.data?.savedReports?.map((report) => report._id) ||
                [];
              setSavedReports(savedReportIds); // Set only the report IDs
            } catch (saveError) {
              console.log("No saved reports found");
            }
          }
        } catch (error) {
          console.error("Error fetching reports:", error);
          setReports([]);
        } finally {
          setLoading(false);
        }
      };

      fetchReports();
    }
  }, []);

  const filteredReports = reports.filter((report) => {
    const title = report.reportTitle || "";
    // const description = report.description || "";
    const reportName = report.summary || "";

    return (
      title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      // description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      reportName.toLowerCase().includes(searchQuery.toLowerCase())
    );
  });

  const indexOfLastReport = currentPage * reportsPerPage;
  const indexOfFirstReport = indexOfLastReport - reportsPerPage;
  const currentReports = filteredReports.slice(
    indexOfFirstReport,
    indexOfLastReport
  );

  if (loading) {
    return <p className="text-center text-gray-500">Loading reports...</p>;
  }
  return (
    <div className="space-y-4">
      {currentReports.length > 0 ? (
        currentReports.map((report) => {
          const isSaved = savedReports.includes(report._id); // Check if the report is saved
          return (
            <div
              key={report._id}
              className="p-4 bg-white rounded shadow flex justify-between items-center hover:border-2 border-[#f33f7d]"
            >
              <div
                onClick={() => handleViewReport(report)}
                className="cursor-pointer"
              >
                <h3 className="font-semibold font5 text-lg font-poppins">
                  {`${
                    report?.reportTitle
                  } Market Size Study & Forecast Outlook, ${
                    report?.Title_year[0]?.year
                  }-${
                    report?.Title_year[report?.Title_year?.length - 1]?.year
                  } (US$M)` || "No Name"}
                </h3>
                <p className="font3 font-poppins mt-2">
                  <strong>Segments:</strong>{" "}
                  {report.allSegments && report.allSegments.length > 0
                    ? [
                        ...new Set(
                          report.allSegments.flatMap(
                            (segment) => segment.segment
                          )
                        ),
                      ].join(", ")
                    : "No Segments Available"}
                </p>
                {/* <p className="font3 font-poppins mt-2">
                  <strong>Segments:</strong>{" "}
                  {report.segments && report.segments.length > 0
                    ? [
                        ...new Set(
                          report.segments.flatMap((segment) =>
                            segment.segments?.map(
                              (nestedSegment) => nestedSegment.name
                            )
                          )
                        ),
                      ].join(", ")
                    : "No Segments Available"}
                </p> */}
                {/* <button
                  className="mt-4 px-4 py-2 bg-lightPink font2 rounded flex items-center font-euclid text-sm"
                  onClick={() => handleViewReport(report)}
                >
                  <img
                    src="images/report.png"
                    alt="Report"
                    className="w-6 h-6 mr-2"
                  />
                  View Report
                </button> */}
              </div>
              {userID && ( // Only render the save button and star if the user is logged in
                <button
                  className="transition-colors duration-200 flex-shrink-0"
                  onClick={() => toggleSaveReport(report._id)} // Use `report._id` to ensure the correct ID is passed
                >
                  <MdOutlineStar
                    className={`w-6 h-6 sm:w-8 sm:h-7 ${
                      isSaved ? "text-pink-500" : "text-gray-400"
                    }`}
                  />
                </button>
              )}
            </div>
          );
        })
      ) : (
        <p className="text-center text-gray-500">No reports found.</p>
      )}
    </div>
  );
}

export default ReportList;
